module.exports = " <div class=breadcrumb__container> <div class=container> <ol class=\"breadcrumb bg-transparent\"> <li class=breadcrumb-item><a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}><i class=\"fa fa-home\"></i></a></li> <li class=\"breadcrumb-item active\"><span>Página no encontrada</span></li> </ol> </div> </div> <div class=\"container mb30\"> <div class=row> <div class=col-md-12> <div class=\"row contenido-404 mb30\"> <advertisement sh-ctrl=$ctrl.shCtrl type-content=espacios positions=1 page-name=PAG-8></advertisement> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/static-views/views/not-found-page.html
 ** module id = 890
 ** module chunks = 7
 **/